import React from 'react';
import { StyleSheet, TouchableOpacity, View } from 'react-native';

import { theme } from '@garnish/constants';
import { BodyText } from '@garnish/core';
import { slugify } from '@garnish/forms';

// ────────────────────────────────────────────────────────────────────────────────

export const Callout = (props: Props) => {
  const { title, onPress } = props;

  return (
    <View style={styles.container}>
      <TouchableOpacity
        accessibilityRole="button"
        onPress={onPress}
        style={styles.annotationContainer}
        testID={`callout-${slugify(title)}`}
      >
        <View style={styles.annotationFill}>
          <BodyText numberOfLines={1} sizeMatch={['12']} style={styles.annotationText}>
            {title}
          </BodyText>
        </View>
      </TouchableOpacity>
    </View>
  );
};

// ─── Styles ─────────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    maxWidth: 250,
    alignItems: 'center',
  },
  annotationContainer: {
    alignItems: 'center',
    padding: theme.spacing['2'],
  },
  annotationFill: {
    paddingVertical: theme.spacing['2'],
    paddingHorizontal: theme.spacing['3'],
    borderRadius: theme.radius.medium,
    backgroundColor: theme.colors.WHITE,
    ...theme.elevations['1'],
  },
  annotationText: {
    textAlign: 'center',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  title: string;
  onPress: () => void;
};
